const bindInput = ({value, onChange}, {showZero, treatEmptyStringAsNull} = {}) => ({
    value: showZero ? value ?? "" : value || "",
    onChange: (e) => (treatEmptyStringAsNull ? onChange(e.target.value == "" ? null : e.target.value) : onChange(e.target.value)),
});
exports.bindInput = bindInput;
